import { Routes } from '@angular/router';
import { notConnectedGuard } from './guards/not-connected.guard';
import { createConnectedGuard } from './guards/connected.guard';

export const routes: Routes = [
  {
    path: '404-not-found',
    loadComponent: () =>
      import('./pages/not-found/not-found.page').then((m) => m.NotFoundPage),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth.routes').then((m) => m.routes),
    canActivate: [notConnectedGuard],
  },
  {
    path: 'invitation',
    loadComponent: () =>
      import('./pages/invitation/invitation.page').then(
        (m) => m.InvitationPage,
      ),
  },
  {
    path: 'wizard',
    loadChildren: () =>
      import('./pages/wizard/wizard.routes').then((m) => m.routes),
    canActivate: [createConnectedGuard()],
  },
  {
    path: ':organisationId',
    loadChildren: () =>
      import('./pages/home/home.routes').then((m) => m.routes),
    canActivate: [createConnectedGuard()],
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/dispatch/dispatch.page').then((m) => m.DispatchPage),
  },
  {
    path: '**',
    redirectTo: '/404-not-found',
    pathMatch: 'full',
  },
];
